import { cpf } from 'cpf-cnpj-validator'

export function validaCpf(value: string) {
  return cpf.isValid(value || '') ? true : false
}
